import React from "react";
import "./index.css";

export default function MaintenanceApp() {
  return (
    <main className="min-h-screen bg-slate-950 px-4 py-10 text-slate-100 flex items-center justify-center">
      <section className="w-full max-w-2xl overflow-hidden rounded-3xl border border-slate-700 bg-slate-900 shadow-2xl">
        <div className="h-2 bg-gradient-to-r from-blue-500 via-cyan-400 to-emerald-400" />
        <div className="p-7 text-center sm:p-12">
          <img
            src="/jntugv-logo.png"
            alt="JNTU-GV"
            className="mx-auto mb-6 h-24 w-24 rounded-2xl bg-white object-contain p-2 shadow-lg"
          />
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.24em] text-cyan-300">
            JNTU-GV e-Payment Portal
          </p>
          <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">
            Payment services are temporarily paused
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-base leading-7 text-slate-300">
            The SBI e-Pay service is not yet available for live transactions. Please do not attempt a payment at this time. The portal will reopen after the live integration is formally activated.
          </p>
          <div className="mx-auto mt-8 max-w-md rounded-xl border border-amber-400/40 bg-amber-400/10 px-5 py-4">
            <p className="text-xs font-medium uppercase tracking-widest text-amber-300">Status code</p>
            <code className="mt-2 block break-all text-base font-semibold text-amber-100 sm:text-lg">
              JNTU-GV_PAY_PAUSE
            </code>
          </div>
          <p className="mt-8 text-sm text-slate-400">
            Jawaharlal Nehru Technological University Gurajada, Vizianagaram
          </p>
        </div>
      </section>
    </main>
  );
}
